import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// Password condition wrapper/container Style.
const PasswordConditionWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  border-radius: 4px;
  text-align: left;
`;

// Style for password text validation if true green, if false then red.
const PasswordCondition = styled.div`
  color: ${(props) => (props.condition ? 'green' : 'red')};
  i {
    width: 16px;
  }
`;

// Condition text style to keep text seperate from the icon
const ConditionText = styled.div`
  text-indent: 15px;
  display: inline-block;
`;

class PasswordRestriction extends Component {
  state = {};

  render() {
    const { signUpPassword, repeatPassword } = this.props;
    return (
      <PasswordConditionWrapper>
        <PasswordCondition
          condition={signUpPassword.length > 7}
          data-testid="8-char"
        >
          <i
            className={
              signUpPassword.length > 7 ? 'fas fa-check' : 'fas fa-times'
            }
          />
          <ConditionText>At least 8 characters.</ConditionText>
        </PasswordCondition>
        <PasswordCondition
          condition={/[0-9]/.test(signUpPassword)}
          data-testid="1-num"
        >
          <i
            className={
              /[0-9]/.test(signUpPassword) ? 'fas fa-check' : 'fas fa-times'
            }
          />
          <ConditionText>At least one number.</ConditionText>
        </PasswordCondition>
        <PasswordCondition
          condition={/[A-Z]/.test(signUpPassword)}
          data-testid="1-upper"
        >
          <i
            className={
              /[A-Z]/.test(signUpPassword) ? 'fas fa-check' : 'fas fa-times'
            }
          />
          <ConditionText>At least one uppercase character.</ConditionText>
        </PasswordCondition>
        <PasswordCondition
          condition={/[a-z]/.test(signUpPassword)}
          data-testid="1-lower"
        >
          <i
            className={
              /[a-z]/.test(signUpPassword) ? 'fas fa-check' : 'fas fa-times'
            }
          />
          <ConditionText>At least one lowercase character.</ConditionText>
        </PasswordCondition>
        <PasswordCondition
          condition={/[^A-Za-z0-9]/.test(signUpPassword)}
          data-testid="1-special"
        >
          <i
            className={
              /[^A-Za-z0-9]/g.test(signUpPassword)
                ? 'fas fa-check'
                : 'fas fa-times'
            }
          />
          <ConditionText>At least one special character.</ConditionText>
        </PasswordCondition>
        <PasswordCondition
          condition={
            signUpPassword === repeatPassword &&
            signUpPassword !== '' &&
            repeatPassword !== ''
          }
          data-testid="match-password"
        >
          <i
            className={
              signUpPassword === repeatPassword &&
              signUpPassword !== '' &&
              repeatPassword !== ''
                ? 'fas fa-check'
                : 'fas fa-times'
            }
          />
          <ConditionText>Password Matched.</ConditionText>
        </PasswordCondition>
      </PasswordConditionWrapper>
    );
  }
}

PasswordRestriction.propTypes = {
  signUpPassword: PropTypes.string.isRequired,
  repeatPassword: PropTypes.string.isRequired,
};

export default PasswordRestriction;
